import {
    FETCH_DEVICE_BY_HEALTH_DEVICE_ID_START,
    FETCH_DEVICE_BY_HEALTH_DEVICE_ID_SUCCESS,
    FETCH_DEVICE_BY_HEALTH_DEVICE_ID_FAIL
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    device: null,
    deviceFetching: false,
    deviceSuccess: false,
    deviceFail: false
};

const deviceFetching = (state) => ({
    ...state,
    deviceFetching: true
});

const deviceFetchFinished = (isSuccess) => (state, action) => ({
    ...state,
    device: isSuccess ? action.data : null,
    deviceFetching: false,
    deviceSuccess: isSuccess,
    deviceFail: !isSuccess
});

export const isDeviceFetching = (state) => state.deviceByHealthDeviceId.deviceFetching;
export const isDeviceSuccess = (state) => state.deviceByHealthDeviceId.deviceSuccess;
export const isDeviceFail = (state) => state.deviceByHealthDeviceId.deviceFail;
export const getDevice = (state) => state.deviceByHealthDeviceId.device;

const handlers = {
    [FETCH_DEVICE_BY_HEALTH_DEVICE_ID_START]: deviceFetching,
    [FETCH_DEVICE_BY_HEALTH_DEVICE_ID_SUCCESS]: deviceFetchFinished(true),
    [FETCH_DEVICE_BY_HEALTH_DEVICE_ID_FAIL]: deviceFetchFinished(false)
};

export default function device(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
